export default __webpack_public_path__ + "static/media/reviews4.df180565.jpeg";